module.exports = __webpack_public_path__ + "img/answers.d994cb29.svg";